var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "div",
            {
              staticClass: "operations",
              staticStyle: { "margin-top": "5px" },
              style: { display: _vm.operationsDisplay }
            },
            [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: true, "label-position": "left" },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                          _vm.filter.pageNum = 1
                          _vm.toQuery()
                        }
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.BusinessNo"),
                            "label-width": "60px"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_PlsInput") +
                                _vm.$t("SeaExport.BusinessNo"),
                              clearable: ""
                            },
                            model: {
                              value: _vm.filter.bizNo,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "bizNo", $$v)
                              },
                              expression: "filter.bizNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "30px" },
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Company"),
                            "label-width": "40px"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office_All,
                              clearable: "",
                              filterable: "",
                              "default-value": _vm.filter.officeId
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.officeId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "30px" },
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_OperateBy"),
                            "label-width": "50px"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              clearable: "",
                              filterable: ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.operationBy = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          staticStyle: { "margin-left": "30px" },
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TimeQuery"),
                            "label-width": "60px",
                            prop: "startDate"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "daterange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.operationTime,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "operationTime", $$v)
                              },
                              expression: "filter.operationTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.filter.pageNum = 1
                              _vm.toQuery()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "cargo-left-right-resize",
            {
              staticStyle: { height: "100%" },
              attrs: {
                "left-style": {
                  display: "flex",
                  flexDirection: "column",
                  width: _vm.leftWidth
                },
                "right-style": {
                  display: "flex",
                  flexDirection: "column",
                  width: _vm.rightWidth
                },
                "show-right": _vm.showRight
              }
            },
            [
              _c("template", { slot: "left" }, [
                _c(
                  "div",
                  {
                    staticClass: "section grid-wrapper",
                    staticStyle: { height: "100%", padding: "0px" }
                  },
                  [
                    _vm.source !== "HomePage"
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "background-color": "#F5F7F6",
                              padding: "10px",
                              "border-bottom": "1px solid #DDE0E7"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "border-right": "1px solid #DBDFE1"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "20px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_BusinessOperationUpdateDynamics"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _c("cargo-group", {
                      staticStyle: {
                        "margin-left": "37px",
                        height: "100px",
                        overflow: "auto",
                        display: "flex",
                        flex: "1 1 auto",
                        "flex-direction": "column"
                      },
                      attrs: {
                        groups: _vm.actionLogGroupData,
                        "current-row-id": _vm.currentRowId,
                        "show-right": _vm.showRight
                      },
                      on: { change: _vm.groupClickHandle }
                    }),
                    _vm.total <= 0
                      ? _c("cargo-ag-grid-no-row-overlay")
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("template", { slot: "right" }, [
                _c(
                  "div",
                  {
                    staticClass: "section grid-wrapper",
                    staticStyle: { height: "100%", padding: "0px" }
                  },
                  [
                    _vm.source !== "HomePage"
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "background-color": "#F5F7F6",
                              padding: "10px",
                              "border-bottom": "1px solid #DDE0E7"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "border-right-width": "1px",
                                  "border-right-style": "solid",
                                  "border-right-color": "#DBDFE1",
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "20px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_UpdateDetails")
                                      )
                                    )
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "el-icon-close close",
                                  on: { click: _vm.detailCloseHandle }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "10px",
                          "border-bottom": "1px solid #DDE0E7",
                          "margin-left": "20px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c(
                                "span",
                                { staticStyle: { "align-self": "center" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_UpdateContent")
                                    )
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t(
                                      "CargoMsg.Cargo_ResultsDisplayedInYellow"
                                    )
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.findText($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.searchText,
                                    callback: function($$v) {
                                      _vm.searchText = $$v
                                    },
                                    expression: "searchText"
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.findText }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "10px",
                          "margin-left": "20px",
                          overflow: "auto",
                          display: "flex",
                          flex: "1 1 auto",
                          "flex-direction": "column"
                        }
                      },
                      [
                        _c("data-update-log-detail", {
                          staticClass: "find-text-area",
                          staticStyle: { height: "100px" },
                          attrs: { detail: _vm.detail }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0 && _vm.source !== "HomePage",
                    expression: "total>0 && source !== 'HomePage'"
                  }
                ],
                attrs: {
                  "config-module": "10000001",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.total > 0 && _vm.source === "HomePage",
                      expression: "total>0 && source === 'HomePage'"
                    }
                  ],
                  staticStyle: {
                    "min-height": "30px",
                    height: "100%",
                    position: "relative"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { position: "absolute", right: "5px" } },
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "10000002",
                          total: _vm.total,
                          page: _vm.filter.pageNum,
                          limit: _vm.filter.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(_vm.filter, "pageNum", $event)
                          },
                          "update:limit": function($event) {
                            return _vm.$set(_vm.filter, "pageSize", $event)
                          },
                          pagination: _vm.toQuery
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }